export const BACKGROUND_IMAGES = [
  "/images/background/bg-home/DALL·E 2024-10-28 21.03.12-Home-Light.webp",
  "/images/background/bg-home/DALL·E 2024-10-18 21.16.27-Home-Dark.webp",
  "/images/background/bg-career/DALL·E 2024-10-28 20.59.07-career-Light.webp",
  "/images/background/bg-career/DALL·E 2024-10-21 17.43.45-career-Dark.webp",
  "/images/background/bg-projects/DALL·E 2024-10-24 19.31.29-Projects-Light.webp",
  "/images/background/bg-projects/DALL·E 2024-10-20 20.37.01-Projects-Dark.webp",
  "/images/background/bg-about/DALL·E 2024-10-28 20.01.16-About-Light.webp",
  "/images/background/bg-about/DALL·E 2024-10-21 17.46.45-About-Dark.webp",
  "/images/background/bg-contact/DALL·E 2024-10-28 21.02.18-Contact-Light.webp",
  "/images/background/bg-contact/DALL·E 2024-10-18 23.31.19-Contact-Dark.webp",
]
